import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, makeStyles } from '@material-ui/core';
import { useKeycloak } from '@react-keycloak/web';
import { GlobalContext } from 'app/store/globalcontext';
import parse from 'html-react-parser';
import React, { useContext } from 'react';
import { GrClose } from 'react-icons/gr';

const useStyles = makeStyles(() => ({
  link: {
    fontSize: 'large',
    fontWeight: 'bold',
    textTransform: 'none',
  },
  gridModal: {
    textAlign: 'right',
  },
  titulo: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '0px',
  },
  dialogConteudo: {
    padding: '8px 18px',
    borderColor: '#707070',
    borderRadius: '8px',
    borderWidth: '1px',
    margin: '0px 18px',
  },
  conteudo: {
    flexDirection: 'column',
    borderWidth: '1px',
    borderColor: '#707070',
    borderRadius: '8px',
    padding: '20px',
  },
  btFechar: {
    backgroundColor: process.env.REACT_APP_KEYCLOAK_CLIENT_ID === 'financeiro-front' ? '#2e62b8' : '#3da4bc',
    color: '#fff',
    borderRadius: '13px',
    width: '162px',
    height: '43px',
    textTransform: 'none',
    '&:hover': {
      background: process.env.REACT_APP_KEYCLOAK_CLIENT_ID === 'financeiro-front' ? '#2e62b8' : '#3da4bc',
    },
    margin: '15px',
  },
}));

const TermoUsoModal = () => {
  const [modalTermoUso, setModalTermoUso] = useContext(GlobalContext).termoUsoModal;
  const [termoUso] = useContext(GlobalContext).termoUso;
  const classes = useStyles();
  const queryParams = new URLSearchParams(window.location.search);
  const isRedirectLogin = queryParams.get('redirectLogin');
  const { keycloak } = useKeycloak();

  const handleRedirectLogin = () => {
    keycloak.login();
  };

  const handleCloseModal = () => {
    setModalTermoUso(false);
  };

  const Title = (props) => {
    const { children, onClose, ...other } = props;

    return (
      <DialogTitle className={classes.titulo} {...other}>
        {children}
        {onClose ? (
          <IconButton onClick={onClose} style={{ padding: '10px' }}>
            <GrClose style={{ width: '16px' }} />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  };

  const Content = () => {
    return (
      <DialogContent className={classes.dialogConteudo}>{termoUso?.texto ? parse(termoUso?.texto) : ''}</DialogContent>
    );
  };

  const Actions = ({ onClose }) => {
    return (
      <DialogActions>
        <Button className={classes.btFechar} onClick={isRedirectLogin ? handleRedirectLogin : onClose}>
          Fechar
        </Button>
      </DialogActions>
    );
  };

  return (
    <Dialog open={modalTermoUso === 'termoUsoModal'} onClose={handleCloseModal} fullWidth maxWidth="lg" scroll="paper">
      <Title onClose={handleCloseModal} />
      <Content />
      <Actions onClose={handleCloseModal} />
    </Dialog>
  );
};

export default TermoUsoModal;
